var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diy-blank",style:('height:'+_vm.itemStyle.height+'px; background: '+_vm.itemStyle.background)})}
var staticRenderFns = []

export { render, staticRenderFns }